<obg-m-quick-sga-login-container
	*ngIf="isQuickLoginEnabled && isQuickLoginMode && !secureStartEnabled else genericForm"
	[translationPrefix]="translationPrefix"
	(busy)="busy.emit($event)"
	(loginSubmit)="login($event)"
>
	<ng-container ngProjectAs="secondary-button" [ngTemplateOutlet]="secondaryButton"></ng-container>
</obg-m-quick-sga-login-container>
<ng-template #genericForm>
	<obg-m-login-bankid-container *ngIf="secureStartEnabled else oldBankId" />
	<ng-template #oldBankId>
		<obg-m-sga-login-form-container
			[personalNumber]="rememberPersonalNumber$ | async"
			[translationPrefix]="translationPrefix"
			(busy)="busy.emit($event)"
			(loginSubmit)="login($event)"
			submitBtnKey="login.submit"
		>
			<p *ngIf="showLoginTitle" [innerHtml]="'login.bank-id.description' | translate" class="login-title"></p>
			<ng-container
				*ngIf="isQuickLoginEnabled"
				ngProjectAs="secondary-button"
				[ngTemplateOutlet]="secondaryButton"
			></ng-container>
		</obg-m-sga-login-form-container>
	</ng-template>
</ng-template>
<ng-template #secondaryButton>
	<button
		mat-stroked-button
		color="accent"
		class="secondary-button"
		test-id="secondary-login-submit"
		data-test-id="secondary-login-submit"
		(click)="switchDevice()"
	>
		{{ secondaryButtonTranslationKey | translate }}
	</button>
</ng-template>
